import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import ActivityLog from '@/modules/ActivityLog';
import { useHasAccess } from '@/modules/core';

import ExpessSetupWrapper from '../ExpessSetupWrapper';

const ExpressSetupActivityLogs: React.FC = () => {
  const hasActivityLog = useHasAccess([{ permission: Permissions.EXPRESS_SETUP }]);
  if (!hasActivityLog) return null;

  return (
    <ExpessSetupWrapper
      isShimmerHide
    >
      <Text weight={700} size="32px" color="textTitle" margin={{ bottom: 'l' }} style={{ lineHeight: '44px' }}>Activity Log</Text>
      <Box
        data-testid="activity-log-exress-setup"
        pad="l"
        background="module"
        round="container1Round"
      >
        <ActivityLog />
      </Box>
    </ExpessSetupWrapper>
  );
};
export default ExpressSetupActivityLogs;
